/* Shopify native storefront: no credentials, external checkout, or captured variant IDs. */
(() => {
  'use strict';
  const config = window.native808 || {};
  const root = config.root || '/';
  const money = value => new Intl.NumberFormat('fr-FR', {style:'currency',currency:config.currency || 'EUR'}).format(value / 100);
  const shortMoney = value => new Intl.NumberFormat('en-IE', {style:'currency',currency:config.currency || 'EUR',minimumFractionDigits: value % 100 ? 2 : 0}).format(value / 100);
  const q = (s, scope = document) => scope.querySelector(s);
  const qa = (s, scope = document) => [...scope.querySelectorAll(s)];
  let lastFocus = null;
  let activeDrawer = null;
  let backdrop = null;
  const notify = message => {
    const toast = q('.native-toast');
    if (!toast) return;
    toast.textContent = message; toast.hidden = false;
    clearTimeout(notify.timer); notify.timer = setTimeout(() => {toast.hidden = true;}, 4000);
  };
  function closeDrawer() {
    activeDrawer?.classList.remove('is-open', 'drawer--visible');
    if(activeDrawer) activeDrawer.setAttribute('aria-hidden','true');
    activeDrawer = null;
    backdrop?.remove(); backdrop = null;
    document.body.classList.remove('native-drawer-lock');
    qa('[data-drawer-toggle="hamburger"]').forEach(el => el.setAttribute('aria-expanded', 'false'));
    lastFocus?.focus(); lastFocus = null;
  }
  function openDrawer(drawer) {
    if (!drawer) return;
    if (activeDrawer) closeDrawer();
    lastFocus = document.activeElement; activeDrawer = drawer;
    drawer.classList.remove('display-none'); drawer.classList.add('is-open','drawer--visible');
    drawer.setAttribute('aria-hidden','false');
    backdrop = document.createElement('div'); backdrop.className = 'native-menu-backdrop';
    backdrop.addEventListener('click', closeDrawer); document.body.append(backdrop);
    document.body.classList.add('native-drawer-lock');
    q('button,a[href]',drawer)?.focus();
  }
  async function request(url, options = {}) {
    const response = await fetch(url, {...options, headers: {Accept:'application/json', ...(options.headers || {})}});
    const data = await response.json();
    if(!response.ok) throw new Error(data.description || data.message || 'Please try again.');
    return data;
  }
  async function refreshCart(open = false) {
    const [cart, html] = await Promise.all([
      request(root+'cart.js'),
      fetch(root+'?section_id=cart-drawer').then(r => {if(!r.ok)throw new Error('Unable to update cart.');return r.text();})
    ]);
    const parsed = new DOMParser().parseFromString(html,'text/html');
    const fresh = q('[data-native-cart-drawer]',parsed);
    const existing = q('[data-native-cart-drawer]');
    if(fresh && existing) existing.innerHTML = fresh.innerHTML;
    qa('[data-header-cart-count]').forEach(e => {e.textContent='('+cart.item_count+')'; e.dataset.headerCartCount=cart.item_count;});
    qa('[data-header-cart-price]').forEach(e => e.textContent=money(cart.total_price));
    qa('[data-header-cart-full]').forEach(e => e.dataset.headerCartFull=String(cart.item_count>0));
    if(open && fresh) openDrawer(existing);
    else if(open) location.assign(root+'cart');
  }
  function setupProduct(scope) {
    if(scope.dataset.nativeReady) return;
    scope.dataset.nativeReady='true';
    const data = JSON.parse(q('[data-native-product-json]',scope).textContent);
    const form = q('.native-product-form',scope);
    const media = qa('[data-native-media]',scope);
    const thumbs = qa('[data-native-thumb]',scope);
    const galleryDots = qa('[data-native-dot]',scope);
    let active = 0;
    const show = index => {
      if(!media.length)return;
      active=(index+media.length)%media.length;
      media.forEach((e,i) => {e.hidden=i!==active;e.classList.toggle('is-active',i===active);if(i!==active)qa('video',e).forEach(v=>v.pause());});
      thumbs.forEach((e,i)=>{e.classList.toggle('is-activated',i===active);e.setAttribute('aria-pressed',String(i===active));});
      galleryDots.forEach((e,i)=>{e.classList.toggle('is-selected',i===active);if(i===active)e.setAttribute('aria-current','step');else e.removeAttribute('aria-current');});
    };
    thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
    galleryDots.forEach((dot,i)=>dot.addEventListener('click',()=>show(i)));
    q('.native-gallery-prev',scope)?.addEventListener('click',()=>show(active-1));
    q('.native-gallery-next',scope)?.addEventListener('click',()=>show(active+1));
    const gallery = q('[data-native-gallery]',scope);
    let touchX;
    gallery?.addEventListener('touchstart',e=>{touchX=e.changedTouches[0].screenX;},{passive:true});
    gallery?.addEventListener('touchend',e=>{const dx=e.changedTouches[0].screenX-touchX;if(Math.abs(dx)>45)show(active+(dx<0?1:-1));},{passive:true});
    const selected = () => qa('[data-native-option]',scope).map(field=>q('input:checked',field)?.value);
    function updateVariant(changeURL=true) {
      const options = selected();
      const variant = options.length ? data.variants.find(v=>v.options.every((o,i)=>o===options[i])) : data.variants[0];
      const available=!!variant?.available;
      const id=q('[data-native-variant-id]',scope);
      id.value=variant?.id || '';id.disabled=!variant;
      const button=q('[data-native-add]',scope);button.disabled=!available;
      q('[data-native-add-text]',scope).textContent=available?'Add to Cart':variant?'Sold Out':'Unavailable';
      if(variant){
        q('[data-native-price]',scope).textContent=money(variant.price);
        const compare=q('[data-native-compare]',scope);compare.hidden=!(variant.compare_at_price>variant.price);compare.textContent=compare.hidden?'':money(variant.compare_at_price);
        const qty=Math.max(1,parseInt(q('[name="quantity"]',scope).value,10)||1);
        q('[data-quantity-change="-1"]',scope).disabled=qty<=1;
        q('[data-native-button-price]',scope).textContent=shortMoney(variant.price*qty);
        if(changeURL){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}
        if(variant.featured_media){const n=media.findIndex(m=>String(m.dataset.nativeMedia)===String(variant.featured_media.id));if(n>=0)show(n);}
      }
      qa('[data-native-option]',scope).forEach((field,i)=>{
        const label=q('[data-native-option-label]',field);if(label)label.textContent=options[i];
        qa('input[type="radio"]',field).forEach(input=>{
          const viable=data.variants.some(v=>v.available&&v.options.every((vopt,n)=>vopt===(n===i?input.value:options[n])));
          input.classList.toggle('native-unavailable',!viable);
          input.classList.toggle('sold-out',!viable);
          input.setAttribute('aria-label',input.value+(viable?'':' — Sold Out'));
        });
      });
      const payment=q('[data-native-payment]',scope);if(payment)payment.hidden=!available;
      const stock=q('[data-native-stock]',scope);if(stock)stock.hidden=available;
      id.dispatchEvent(new Event('change',{bubbles:true}));
    }
    qa('[data-native-option] input',scope).forEach(e=>e.addEventListener('change',()=>updateVariant()));
    q('[name="quantity"]',scope)?.addEventListener('change',()=>updateVariant(false));
    form.addEventListener('submit',async e=>{
      e.preventDefault(); const button=q('[data-native-add]',scope);if(button.disabled)return;
      const error=q('[data-native-error]',scope); error.hidden=true;button.disabled=true;button.setAttribute('aria-busy','true');
      try{
        await request(root+'cart/add.js',{method:'POST',body:new FormData(form)});
        try{await refreshCart(true);}catch{location.assign(root+'cart');}
      }catch(err){error.textContent=err.message;error.hidden=false;}
      finally{button.removeAttribute('aria-busy');updateVariant(false);}
    });
    updateVariant(false);
  }
  function setupPromo(scope=document) {
    qa('section[class^="promo-"]',scope).forEach(promo=>{
      if(promo.dataset.nativeReady)return;promo.dataset.nativeReady='true';
      const slides=qa('[class*="__slide"]',promo), dots=q('[class$="__dots"]',promo);let current=0;
      const show=i=>{current=(i+slides.length)%slides.length;slides.forEach((s,n)=>s.classList.toggle('is-active',n===current));qa('button',dots).forEach((d,n)=>{d.classList.toggle('is-active',n===current);d.setAttribute('aria-pressed',String(n===current));});};
      slides.forEach((_,i)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Image '+(i+1));b.addEventListener('click',()=>show(i));dots?.append(b);});
      q('[class$="__arrow--prev"]',promo)?.addEventListener('click',()=>show(current-1));q('[class$="__arrow--next"]',promo)?.addEventListener('click',()=>show(current+1));show(0);
      if(!matchMedia('(prefers-reduced-motion: reduce)').matches){const cycle=setInterval(()=>{if(!promo.isConnected){clearInterval(cycle);return;}if(!document.hidden&&!promo.matches(':hover')&&!promo.contains(document.activeElement))show(current+1);},4000);}
      const counter=q('[data-end]',promo);
      const end=Date.parse(counter?.dataset.end || '');
      const tick=()=>{if(!Number.isFinite(end))return;let remaining=Math.max(0,Math.floor((end-Date.now())/1000));const values=[Math.floor(remaining/86400),Math.floor(remaining/3600)%24,Math.floor(remaining/60)%60,remaining%60];qa('[class$="__cd-num"]',promo).forEach((e,i)=>e.textContent=String(values[i]).padStart(2,'0'));};
      tick();const timer=setInterval(()=>{if(!promo.isConnected)clearInterval(timer);else tick();},1000);
    });
  }
  function initialize(scope=document){
    qa('[data-native-product]',scope).forEach(setupProduct);setupPromo(scope);
    qa('[data-native-recommendations]',scope).forEach(el=>{
      if(el.dataset.loaded)return;el.dataset.loaded='true';
      const observer=new IntersectionObserver(entries=>{if(!entries.some(e=>e.isIntersecting))return;observer.disconnect();fetch(el.dataset.nativeRecommendations).then(r=>r.text()).then(html=>{const source=q('[data-native-recommendations]',new DOMParser().parseFromString(html,'text/html'));if(source)el.innerHTML=source.innerHTML;}).catch(()=>{});},{rootMargin:'300px'});observer.observe(el);
    });
  }
  document.addEventListener('click',async e=>{
    const menu=e.target.closest('[data-drawer-toggle="hamburger"]');
    if(menu){e.preventDefault();if(activeDrawer)closeDrawer();else{openDrawer(q('#header-menu'));menu.setAttribute('aria-expanded','true');}return;}
    if(e.target.closest('[data-native-cart-close]')){closeDrawer();return;}
    if(e.target.closest('[data-drawer-toggle="drawer-cart"]')){e.preventDefault();try{await refreshCart(true);}catch{location.assign(root+'cart');}return;}
    const remove=e.target.closest('[data-native-remove]');
    if(remove){e.preventDefault();remove.disabled=true;try{await request(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:remove.dataset.nativeRemove,quantity:0})});await refreshCart();}catch(err){notify(err.message);remove.disabled=false;}return;}
    const accordion=e.target.closest('[data-accordion-trigger]');
    if(accordion){const body=document.getElementById(accordion.getAttribute('aria-controls'));if(!body)return;const expanded=accordion.getAttribute('aria-expanded')!=='true';accordion.setAttribute('aria-expanded',String(expanded));body.classList.toggle('native-expanded',expanded);return;}
    const qty=e.target.closest('[data-quantity-change]');
    if(qty){const input=q('input',qty.parentElement);input.value=Math.max(1,(parseInt(input.value,10)||1)+Number(qty.dataset.quantityChange));input.dispatchEvent(new Event('change',{bubbles:true}));return;}
    const zoom=e.target.closest('[data-native-zoom]');
    if(zoom){const dialog=q('.native-zoom');q('img',dialog).src=zoom.dataset.nativeZoom;q('img',dialog).alt=q('img',zoom.closest('.product-image-wrapper'))?.alt||'Product image';dialog.showModal();return;}
    if(e.target.closest('.native-zoom-close'))q('.native-zoom').close();
  });
  document.addEventListener('keydown',e=>{
    if(e.key==='Escape'&&activeDrawer)closeDrawer();
    if((e.key==='Enter'||e.key===' ')&&e.target.matches('[data-accordion-trigger][role="button"]')){e.preventDefault();e.target.click();}
    if(e.key==='Tab'&&activeDrawer){const focusable=qa('a[href],button:not([disabled]),input:not([disabled]),select,textarea',activeDrawer).filter(el=>el.getClientRects().length);const first=focusable[0],last=focusable.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}}
  });
  const onScroll=()=>q('[data-header-wrapper]')?.classList.toggle('native-scrolled',scrollY>20);
  addEventListener('scroll',onScroll,{passive:true});onScroll();
  initialize();document.addEventListener('shopify:section:load',e=>initialize(e.target));
})();
